import Vue from "vue";

import Vuetify from "vuetify";

import "@/styles/global.scss";

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
	console.warn = () => { };
}


/**
 * Plugins
 */
// i18n
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import messages from "./i18n/global/en.json";

const i18n = new VueI18n({
	locale: "en",
	messages,
});

Vue.use(Vuetify);


import TeamHubPlugin from "@/plugins/team-hub";
Vue.use(TeamHubPlugin);

import SnackbarPlugin from "@/plugins/snackbar";
Vue.use(SnackbarPlugin, { store });

import TeamPlugin from "@/plugins/team";
Vue.use(TeamPlugin, { store });

import APIPlugin from "@/plugins/api";
Vue.use(APIPlugin, { store });

/**
 * Components
 */
import Footer from "@/components/_global/Footer.vue";
Vue.component("app-footer", Footer);

import Select from "@/components/_global/Select.vue";
Vue.component("app-select", Select);

import CenteredMessage from "@/components/_global/CenteredMessage.vue";
Vue.component("app-centered-message", CenteredMessage);

import DataTable from "@/components/_global/DataTable.vue";
Vue.component("data-table", DataTable);

import Dialog from "@/components/_global/Dialog.vue";
Vue.component("app-dialog", Dialog);

import Loading from "@/components/_global/Loading.vue";
Vue.component("app-loading", Loading);

/**
 * Mixins
 */
import { DragDropContext } from "vue-react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
// import "./registerServiceWorker";

new Vue({
	mixins: [DragDropContext(HTML5Backend)],
	router,
	store,
	i18n,
	// @ts-ignore
	vuetify: new Vuetify({
		icons: {
			iconfont: "mdi",
		},
		theme: {
			themes: {
				light: {
					navigationDrawer: "#2c2541",
					dropAreaIsOver: "#E6E6E6",
					"v-toolbar": "#fff",
					"v-data-table": "#fff",
					"v-card": "#fff",
					"v-pagination__item": "#fff",
					"v-pagination__item--active": "#1976D2",
					"v-pagination__navigation": "#fff",
				},
				dark: {
					navigationDrawer: "#1d192b",
					dropAreaIsOver: "#606060",
					"v-toolbar": "#424242",
					"v-data-table": "#424242",
					"v-card": "#424242",
					"v-pagination__item": "#424242",
					"v-pagination__item--active": "#2196f3",
					"v-pagination__navigation": "#424242",
				}
			}
		},
	}),
	render: (h) => h(App),
}).$mount("#app");
